const OUTAGE_REASONS = {
  PLANNED_OUTAGE: 'PLANNED_OUTAGE',
  UNPLANNED_OUTAGE: 'UNPLANNED_OUTAGE'
};
export { OUTAGE_REASONS };